<template>
    <div v-if='!siteBean.loading' class='screenContent' >
        <div class='row' id='interactivesScreen' >
            <div class='col-sm-6 text-center' v-for='image in siteBean.interactivesData.list' :style='"background-color: #" + image.color' >
                <h1>
                    {{image.title}}
                </h1>
                <interactive-image
                    :url='siteBean.url'
                    :interfaceUrl='[siteBean.urlData, siteBean.interfaceData.path].join("/")'
                    :dataUrl='[siteBean.urlData, siteBean.interactivesData.path].join("/")'
                    :soundEnable='true'
                    :data='image'
                    :projectionBean='projectionBean'>
                </interactive-image>
                <p v-html='image.description'/>
            </div>
        </div>
    </div>
</template>
<script>
    import ProjectionBean from '@/scripts/ProjectionBean.js';
    import SiteBean from '@/scripts/SiteBean.js';

    export default {
        data() {
            return {
                projectionBean: ProjectionBean.getInstance(),
                siteBean: SiteBean.getInstance()
            };
        },
        mounted() {
            this.projectionBean.toDisconnected();
        }
    }

</script>
<style></style>
